<template>
  <!-- 用户端查看蜜蜂发现主页信息 -->
  <div class="discovery_beedetails_info">
    <van-sticky>
      <navTitle title="蜜蜂主页" hideImg="true" v-if="showTitle"/>
    </van-sticky>
    <beeHeader :item="beesInfo" :showFollew="beesInfo.isFollow" v-if="beesInfo.beesId"/>
    <div class="search_content">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <Waterfall
            :minCol="2"
            :maxCol="2"
            :percent="[1,1]"
            :gutterHeight="10"
            :width="itemWidth"
            :gutterWidth="gutterWidth"
          >
            <itemContent pageCode="5011101" v-for="(item,index) in list" :key="index" :item="item" :likeCount="item.likeCount" :like="item.like" isNavtie="1"/>
          </Waterfall>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script>
import beeHeader from "./components/beeInfo";
import navTitle from "./components/navTitle";
import itemContent from "./components/itemContent";
import { Waterfall } from "vue2-waterfall";
import http from "@/utils/axios";
import utils from "@/utils/common";
export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      showTitle:true,
      refreshing: false,
      pageNum: 0,
      beesUserId:'',
      beesInfo:{}
    };
  },
  methods: {
    onLoad() {
      this.pageNum++;
      this.getData();
    },
    onRefresh() {
      setTimeout(() => {
        this.refreshing = false;
        this.pageNum = 1;
        this.list=[];
        this.getData();
      }, 2000);
    },
    getData() {
      let parmes ={
        beesUserId: this.$route.query.beesUserId || this.beesUserId,
        pageNum: this.pageNum,
        pageSize: 20
      }
      if(parmes.beesUserId){
      http({
        url: "/discover/appuser/beesdiscover/beesdiscoverlist",
        method: "post",
        parmes: parmes
      }).then(rps => {
        if (rps.code == 200) {
          if (rps.data.pages == 0) {
            this.finished = true;
          } else {
            if (rps.data.list.length === 0) {
              this.finished = true;
            } else {
              this.finished = false;
              this.pageIndex++;
            }
            this.list = this.list.concat(rps.data.list);
          }
          this.loading = false;
        }
      });
      }
    },
    getBeesInfo(){
      let parmes={
        beesUserId:this.$route.query.beesUserId
      }
      http({
        url:'/discover/appbees/discover/bees/basedata',
        method:'post',
        parmes:parmes
      }).then(rps=>{
        if(rps.code===200){
          this.beesInfo = rps.data;
          if(window.tools.isWechat()) {
            document.title = this.beesInfo.beesName
          }
        }
      })
    }
  },
  components: {
    beeHeader,
    itemContent,
    Waterfall,
    navTitle
  },
  computed: {
    itemWidth() {
      return 133 * 0.5 * (document.documentElement.clientWidth / 375);
    },
    gutterWidth() {
      return 10 * 0.5 * (document.documentElement.clientWidth / 375);
    }
  },
  created() {
    if(window.tools.isWechat()){
      this.showTitle=false;
    }
    this.beesUserId = this.$route.query.beesUserId;
    this.getBeesInfo();
    this.$loading.hide();
    utils.nativeMethod({ tm: "1000003", tp: { noTitle:"1" } });
  }
};
</script>
<style lang="less" scoped>
.discovery_beedetails_info {
  .search_content {
    background-color: #F7F7F7;
    // margin-top: 20px;
    padding: 20px 10px;
    min-height: 900px;
  }
}
</style>